const url_debug = 'http://localhost:49833';    // Localhost
//const url_debug = 'https://openday.battisti.it/api';    // Localhost

export default {

  getUrl() {
    if (window.location.host.includes("localhost"))
      return url_debug

    return window.location.protocol + "//" + window.location.host
  },

  getUrlApi() {

    let url = this.getUrl();

    if (url.includes("localhost"))
      url += "/api"
    else
      url += "/api/api"

    return url
  },

}